export class DeleteFertilizerByIdUseCase {
  constructor(api){
    this.api=api
  }
  async execute(id) {
    const raw = `
      DELETE FROM CROP.FERTILIZER
      WHERE ID=${id};
    `
    const resp= await this.api.sql({
      data:{
        sql:raw
      }
    })

    return resp
  }
}
